import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Title, Table, Grid, MediaQuery, Anchor, Text, Accordion, Center, Loader } from '@mantine/core';
import externalApi from '../api';
import endpoints from '../api/endpoints';

type SDPlusTime = {
  display_value: string;
  value: string;
};

type Ticket = {
  ticketId: number;
  ticketSubject: string;
  ticketShortDescription: string;
  createdDateTime: SDPlusTime;
};

const MyTickets = () => {
    const [tickets, setTickets] = useState<Ticket[]>([]);
    const [isLoaded, setIsLoaded] = useState(false);

  async function loadTickets() {
    const myTickets: Ticket[] = await externalApi.get(endpoints.getMyTickets.url).json();   
      setTickets(myTickets);
      setIsLoaded(true);
  }

  useEffect(() => {
    loadTickets();
  }, []);

    const hideIfMobile = {
        display: 'none',
    };

    const hideIfDesktop = {
        display: 'none',
    };

  return (
    <>
          <Title order={1}>My Tickets</Title>
          <Grid grow>
              <Grid.Col>
                  {!isLoaded && <Center><Loader my="xl" color="blue" size="lg" /></Center>}
                  {isLoaded && <MediaQuery smallerThan="md" styles={hideIfMobile}>

                      <Table sx={{ minWidth: 700, whiteSpace: 'nowrap' }} striped>
                          <thead>
                              <tr>
                                  <th>Ticket ID</th>
                                  <th>Subject</th>
                                  <th>Created Time</th>
                                  <th></th>
                                  <th></th>
                              </tr>
                          </thead>
                          <tbody>
                              {tickets.length > 0 &&
                                  tickets.map((ticket) => (
                                      <tr key={ticket.ticketId}>
                                          <td>{ticket.ticketId}</td>
                                          <td>{ticket.ticketSubject}</td>
                                          <td>{ticket.createdDateTime.display_value}</td>

                                          <td>
                                              <Button color="blue" size="sm" my="sm" component={Link} to={`/ticket/${ticket.ticketId}`}>
                                                  Ticket Details
                                              </Button>
                                          </td>


                                      </tr>
                                  ))}
                          </tbody>
                      </Table>

                  </MediaQuery>}               
                  {isLoaded && <MediaQuery largerThan="md" styles={hideIfDesktop}>
                      
                       <Accordion multiple>
                          {tickets.length > 0 &&
                              tickets.map((ticket) => (
                                  <Accordion.Item key={ticket.ticketId} label={ticket.ticketSubject}>
                                      Created on: {ticket.createdDateTime.display_value}
                                      <Center><Button color="blue" variant="subtle" size="sm" my="sm" component={Link} to={`/ticket/${ticket.ticketId}`}>
                                          Ticket Details
                                      </Button></Center>
                                  </Accordion.Item>
                              ))}
                      </Accordion>
                      
                      {/*<Table striped>*/}
                      {/*    <thead>*/}
                      {/*        <tr>*/}
                      {/*            <th>ID</th>*/}
                      {/*            <th>Subject</th>*/}
                      {/*            <th>Created Time</th>*/}
                      {/*        </tr>*/}
                      {/*    </thead>*/}
                      {/*    <tbody>*/}
                      {/*        {tickets.length > 0 &&*/}
                      {/*            tickets.map((ticket) => (*/}
                      {/*                <tr key={ticket.ticketId}>*/}
                      {/*                    <td><Anchor component={Link} to={`/ticket/${ticket.ticketId}`}><Text color="blue">{ticket.ticketId}</Text></Anchor></td>*/}
                      {/*                    <td>{ticket.ticketSubject}</td>*/}
                      {/*                    <td>{ticket.createdDateTime.display_value}</td>*/}
                      {/*                </tr>*/}
                      {/*            ))}*/}
                      {/*    </tbody>*/}
                      {/*</Table>*/}
                  </MediaQuery>}
              </Grid.Col>
          </Grid>
    </>
  );
};

export default MyTickets;
